import axios from 'axios';
import { getDomain } from '../pc.config';
// axios.defaults.withCredentials = true; //允许带cookie

export default async (param) => {
    return new Promise(async (resolve, reject) => {
        try {
			param.headers = {
				'content-type':'application/x-www-form-urlencoded',
				...param.headers
			}
			if(param.notCookie){
				axios.defaults.withCredentials = false
			}else{
                axios.defaults.withCredentials = true
			}
			param.params = param.data;
            param.url = param.url.includes('http') ? param.url : getDomain(param.url)
            let data = await axios(param);
            if(data.status==200){
                resolve(data.data)
            }else{
                reject(999)
            }
        } catch (error) {
            reject(error)
        }
    })

}


// WEBPACK FOOTER //
// ./src/lib/request.js